import React, { createContext, useContext, useEffect, useState } from 'react';
import { notification } from "antd";
import { useValidateLogin } from './services/auth.service';
import { participantPayload } from './Payload';
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const navigate = useNavigate();

   // const [user, setUser] = useState(JSON.parse(sessionStorage.getItem('participant_user')));
    const [user, setUser] = useState({...participantPayload, id: (JSON.parse(sessionStorage.getItem('participant_user')))?.id });
    const [event, setEvent] = useState(JSON.parse(localStorage.getItem('participant_event')));

    const [token, setToken] = useState(sessionStorage.getItem('participant_token'));
    const [mobileNumber, setMobileNumber] = useState(sessionStorage.getItem('participant_mobile'));

    const { data: loginUser, mutate: validateLogin, isSuccess, isError, error } = useValidateLogin();


    useEffect(() => {

        getToken();
    }, []);

    useEffect(() => {
        if (isSuccess && loginUser?.data) {
            const { tokenType, accessToken, refreshToken } = loginUser.data;

            setToken(accessToken);
            sessionStorage.setItem('participant_token', accessToken);
        }
    }, [isSuccess, loginUser?.data]);

    const getToken = () => {
        validateLogin({ 'email': 'ad1@aoholdings.net', 'password': 'Password@1' });
    }

    const login = (mobilePhone, participant) => {

        setMobileNumber(mobilePhone);
        sessionStorage.setItem('participant_mobile', mobilePhone);

        if (participant.length > 0) {
            //setUser(participant[0]);
            setUser(() => ({ ...participantPayload, id:participant[0].id}));
            sessionStorage.setItem('participant_user', JSON.stringify(participant[0]));
        }else{//participantPayload
            setUser(participantPayload);
            sessionStorage.setItem('participant_user', JSON.stringify(participantPayload));
        }

        // navigate('/#/event');

        window.location.reload();
    };

    const logout = () => {
        setUser(null);
        setMobileNumber(null);

        sessionStorage.removeItem(`participant_user`);
        sessionStorage.removeItem(`participant_mobile`);
        localStorage.removeItem('participant_event');

        window.location.assign(`/workshop-event/${event?.id}`);
    };



    return (
        <AuthContext.Provider value={{ 
            user, login, logout, setUser, participantPayload ,
            event, setEvent, mobileNumber
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuthContext = () => useContext(AuthContext);
